'use client';

import { useEffect } from 'react';

/**
 * Корневая ошибка: срабатывает, когда сбой произошёл вне сегмента локали.
 * Провайдера переводов и темы здесь нет, поэтому страница самодостаточна,
 * а стили заданы явно.
 */
export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Корневая ошибка:', error.digest ?? error.message);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '32px',
        textAlign: 'center',
        background: '#0b0f19',
        color: '#e5e7eb',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      }}
    >
      <svg viewBox="0 0 96 96" width="56" height="56" fill="none" aria-hidden="true">
        <path
          d="M 62 20 A 34 34 0 1 0 62 76"
          stroke="#6366f1"
          strokeWidth="11"
          strokeLinecap="round"
        />
        <path
          d="M 44 34 L 60 48 L 44 62"
          stroke="#6366f1"
          strokeWidth="11"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <p style={{ fontSize: '56px', fontWeight: 700, margin: 0, lineHeight: 1, color: '#6b7280' }}>
        500
      </p>
      <h1 style={{ fontSize: '20px', fontWeight: 600, margin: 0 }}>Something went wrong</h1>
      <p style={{ color: '#9ca3af', margin: 0, maxWidth: '420px', lineHeight: 1.6 }}>
        An unexpected error occurred on our side. Please try again.
      </p>

      <div style={{ display: 'flex', gap: '12px', marginTop: '8px', flexWrap: 'wrap' }}>
        <button
          onClick={reset}
          style={{
            padding: '12px 28px',
            borderRadius: '12px',
            background: '#6366f1',
            color: '#fff',
            fontWeight: 600,
            border: 'none',
            cursor: 'pointer',
            fontSize: '15px',
          }}
        >
          Try again
        </button>
        <a
          href="/"
          style={{
            padding: '12px 28px',
            borderRadius: '12px',
            border: '1px solid #232a3d',
            color: '#e5e7eb',
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Go to homepage
        </a>
      </div>

      {error.digest && (
        <p style={{ marginTop: '24px', fontSize: '12px', color: '#6b7280' }}>
          ID: <code style={{ fontFamily: 'monospace' }}>{error.digest}</code>
        </p>
      )}
    </div>
  );
}
